export const BG_ISO_COOKIE_NAME = 'countryISO';
export const BG_CHANNEL_COOKIE_NAME = 'cookieSelectedChannel';
export const BG_REGION_COOKIE_NAME = 'cookieSelectedRegion';
export const BG_SELF_ATTESTATION_COOKIE_NAME = 'BG_SELF_ATTESTATION';
export const BG_SAVED_FUNDS_ID = 'bgSavedFundsId';
